/**
 * Widevine Key System.
 *
 * @group DRM
 *
 * @beta
 */
export const WIDEVINE_KEY_SYSTEM = 'com.widevine.alpha';
//# sourceMappingURL=WIDEVINE_KEY_SYSTEM.js.map